performance.mark('start_load_main');

import Form from './core/Form';

// element-ui
import {
  Cascader,
  DatePicker,
  Select,
  Option,
  Switch,
  Checkbox,
  Dialog,
  Rate,
} from 'element-ui';

import * as helpers from './core/Functions';

require('es6-promise').polyfill();

Lang.setLocale(siteLang);

// https://github.com/davidchambers/string-format
let format = require('string-format');
format.extend(String.prototype, {});

window.helpers = helpers;
window.Form = Form;

// element-ui
Vue.component(Cascader.name, Cascader);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Switch.name, Switch);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Dialog.name, Dialog);
Vue.component(Rate.name, Rate);

// глобальный объект для модалок
window.modal = {
  type: '',
};

require('./snippets/slider');
require('./snippets/elements');
require('./snippets/common');
require('./snippets/callback');
require('./snippets/auth');
require('./snippets/share_buttons');
require('./connect-comment');
require('./snippets/header');

//lazy image load
import Blazy from 'blazy';

window.Blazy = Blazy;

setTimeout(function () {
  new Blazy({
    breakpoints: [{
      width: 420,
      src: 'data-src-small'
    }]
  });
}, 500);

performance.mark('main_loaded');



// WEBPACK FOOTER //
// ./resources/js/main.js